var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Trigger from '../Trigger';
import Button from './button';
import { ConfigConsumer } from '../ConfigProvider';
import { isFunction } from '../_util/is';
var positionList = [
    'top',
    'tl',
    'tr',
    'bottom',
    'bl',
    'br',
];
var Dropdown = /** @class */ (function (_super) {
    __extends(Dropdown, _super);
    function Dropdown(props) {
        var _this = _super.call(this, props) || this;
        _this.renderPopup = function (prefixCls) {
            var popup = _this.getPopupElement();
            var isMenuPopup = popup && popup.props.isMenu;
            return isMenuPopup
                ? React.cloneElement(popup, {
                    prefixCls: prefixCls + "-menu",
                    selectable: false,
                    onClickMenuItem: _this.onClickMenuItem,
                })
                : popup;
        };
        _this.onClickMenuItem = function (key) {
            var popup = _this.getPopupElement();
            if (popup.props.onClickMenuItem) {
                popup.props.onClickMenuItem(key);
            }
            var child = _this.triggerRef.getRootElement();
            // set focus to avoid onblur
            if (child && child.focus) {
                child.focus();
            }
            _this.setState({
                popupVisible: false,
            });
            _this.handleVisibleChange(false);
        };
        _this.getPopupElement = function () {
            var droplist = _this.props.droplist;
            var child = React.Children.only(droplist || React.createElement("span", null));
            return child;
        };
        // getTransitionClassNameFromPosition = (position = this.props.position): string => {
        //   switch (position) {
        //     case 'top':
        //     case 'tl':
        //     case 'tr':
        //       return 'slideUp';
        //     case 'bottom':
        //     case 'bl':
        //     case 'br':
        //       return 'slideDown';
        //     default:
        //       return 'slideDown';
        //   }
        // }
        _this.handleVisibleChange = function (visible) {
            var onVisibleChange = _this.props.onVisibleChange;
            if (isFunction(onVisibleChange) && visible !== _this.props.popupVisible) {
                onVisibleChange(visible);
            }
        };
        _this.renderDropdown = function (_a) {
            var getPrefixCls = _a.getPrefixCls;
            var _b = _this.props, trigger = _b.trigger, children = _b.children, position = _b.position, unmountOnExit = _b.unmountOnExit, triggerProps = _b.triggerProps, getPopupContainer = _b.getPopupContainer;
            var popupVisible = _this.state.popupVisible;
            var prefixCls = getPrefixCls('dropdown');
            return (React.createElement(Trigger, __assign({ ref: function (ref) { return (_this.triggerRef = ref); }, trigger: trigger, popup: _this.renderPopup.bind(_this, prefixCls), mouseEnterDelay: 400, mouseLeaveDelay: 400, unmountOnExit: unmountOnExit, classNames: "dropdownSlide", position: position, popupAlign: {
                    bottom: 4,
                    top: 4,
                }, getPopupContainer: getPopupContainer }, triggerProps, { popupVisible: popupVisible, onVisibleChange: _this.handleVisibleChange }), children));
        };
        _this.state = {
            popupVisible: false,
        };
        return _this;
    }
    Dropdown.getDerivedStateFromProps = function (nextProps, prevState) {
        if ('popupVisible' in nextProps && nextProps.popupVisible !== prevState.popupVisible) {
            return {
                popupVisible: nextProps.popupVisible,
            };
        }
        return null;
    };
    Dropdown.prototype.render = function () {
        return React.createElement(ConfigConsumer, null, this.renderDropdown);
    };
    Dropdown.displayName = 'Dropdown';
    Dropdown.Button = Button;
    Dropdown.propTypes = {
        position: PropTypes.oneOf(positionList),
        trigger: PropTypes.oneOf(['hover', 'click']),
        unmountOnExit: PropTypes.bool,
        getPopupContainer: PropTypes.func,
    };
    Dropdown.defaultProps = {
        position: 'bottom',
        trigger: 'hover',
        unmountOnExit: true,
    };
    return Dropdown;
}(Component));
export default Dropdown;
